import * as reduxForm from 'redux-form';

const FORM_SUBMISSION = 'gratis-app/FORM_SUBMISSION';

export default function reducer( state = {}, action ) {
    switch ( action.type ) {
        case FORM_SUBMISSION:
            return action.response;
        default:
            return state;
    }
}

export function submit( data ) {
    return {
        type    : FORM_SUBMISSION,
        response: data || {}
    };
}



// WEBPACK FOOTER //
// ./src/form/redux/modules/submission.js